module.exports = __webpack_public_path__ + "static/media/cra.dec9d5fe.png";